import Icon from '../components/Icon.vue'

Icon.register({"angle-double-right":{"width":448,"height":512,"paths":[{"d":"M224.3 273L88.3 409C78.9 418.4 63.7 418.4 54.4 409L31.8 386.4C22.4 377 22.4 361.8 31.8 352.5L128.2 256.1 31.8 159.7C22.4 150.3 22.4 135.1 31.8 125.8L54.3 103C63.7 93.6 78.9 93.6 88.2 103L224.2 239C233.7 248.4 233.7 263.6 224.3 273zM416.3 239L280.3 103C270.9 93.6 255.7 93.6 246.4 103L223.8 125.6C214.4 135 214.4 150.2 223.8 159.5L320.2 255.9 223.8 352.3C214.4 361.7 214.4 376.9 223.8 386.2L246.4 408.8C255.8 418.2 271 418.2 280.3 408.8L416.3 272.8C425.7 263.6 425.7 248.4 416.3 239z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/angle-double-right.js
// module id = vrpP
// module chunks = 0